"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const common_styled_components_1 = require("../../common-styled-components");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const compliance_pool_types_1 = require("../compliance-pool-types");
const apiUtils_1 = require("../../../util/apiUtils");
const useMetadata_1 = require("../../../hooks/useMetadata");
const ComplianceKPI_1 = __importDefault(require("../common/ComplianceKPI"));
const compliance_1 = require("../../../util/compliance/compliance");
const LineChart_1 = __importDefault(require("../LineChart"));
const theme_1 = require("../../../theme");
const util_1 = require("../util");
const TransactionTable_1 = require("../common/tables/TransactionTable");
const ShipTable_1 = require("../common/tables/ShipTable");
const isNonEmptyObject_1 = require("../../../util/isNonEmptyObject");
const YearContext_1 = require("../../../contexts/YearContext");
const react_1 = require("react");
const VoyageBarChart_1 = __importDefault(require("../admin/VoyageBarChart"));
exports.default = () => {
    const { fleetId } = (0, react_router_dom_1.useParams)();
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [fleets, _setUrl, _setBody, _refresh] = (0, useFetch_1.default)("fleet/fleets.json", undefined, true);
    const [ships, _setShipsUrl, _setShipsPostBody] = (0, useFetch_1.default)("ship/ships.json", undefined, true);
    const [usageAnalysis, _setUsageAnalysisUrl, _setUsageAnalysisPostBody] = (0, useFetch_1.default)("fleet/fleet_fuel_usage.json", undefined, true);
    const [voyages, _setVoyagesUrl, _setVoyagesPostBody] = (0, useFetch_1.default)("voyage/voyages.json", undefined, true);
    const [transactions, _setTransUrl, _setTransPostBody, refreshTransactions] = (0, useFetch_1.default)("transaction/transactions.json", undefined, true);
    (0, react_1.useEffect)(() => {
        _setBody(JSON.stringify({
            year: selectedYear,
        }));
        _setShipsPostBody(JSON.stringify({
            year: selectedYear,
            fleet_id: Number(fleetId),
        }));
        _setUsageAnalysisPostBody(JSON.stringify({ fleet_id: Number(fleetId), year: selectedYear }));
        _setVoyagesPostBody(JSON.stringify({ fleet_id: Number(fleetId), year: selectedYear }));
        _setTransPostBody(JSON.stringify({
            fleet_id: Number(fleetId),
            year: selectedYear,
        }));
    }, [selectedYear, fleetId]);
    const [metadata] = (0, useMetadata_1.useMetadata)();
    const fleetData = fleets.status === apiUtils_1.LoaderStatus.Success
        ? fleets.data.find((f) => f.id === Number(fleetId))
        : null;
    const usageData = usageAnalysis.status === apiUtils_1.LoaderStatus.Success
        ? usageAnalysis.data
        : undefined;
    const analysis = usageData?.fleet.analysis;
    const transactionData = transactions.status === apiUtils_1.LoaderStatus.Success ? transactions.data : null;
    const poiData = transactionData?.map((t) => (0, util_1.getTransactionPOI)(t, "neutral")) ?? [];
    const forecastsAvailable = (0, compliance_pool_types_1.isForecast)(usageData?.fleet.forecast) &&
        usageData?.fleet.forecast.total !== undefined;
    const forecastFuels = forecastsAvailable
        ? (0, util_1.combineFuels)(usageData.fleet.forecast.forecast_fuels_total)
        : undefined;
    const forecastDate = forecastsAvailable
        ? new Date(usageData.fleet.forecast.end)
        : undefined;
    // log([
    //   {
    //     label: "Metadata",
    //     content: metadata,
    //   },
    //   {
    //     label: "Fleet data",
    //     content: fleetData ?? "loading",
    //   },
    //   {
    //     label: "Usage analysis",
    //     content: usageData ?? "loading",
    //   },
    // ]);
    const carbonLimitYear = selectedYear;
    if (fleetData && analysis && metadata) {
        return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: fleetData.name }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Ships: " }), fleetData.ships.length] })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: (0, compliance_1.getCompliance)(analysis.intensities.total.adjusted_emission_balance_ton), title: "Carbon intensity", unit: "gCO\u2082e/MJ", value: analysis.intensities.total.adjusted_intensity_gCO2e_per_MJ }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: (0, compliance_1.getCompliance)(analysis.intensities.total.adjusted_emission_balance_ton), title: "Carbon unit balance", unit: analysis.intensities.total.adjusted_emission_balance_ton < 0
                                    ? "tCO₂e deficit"
                                    : "tCO₂e to spare", value: (0, util_1.scaleEmissions)(analysis.intensities.total.adjusted_emission_balance_ton) }) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { "$cols": 2, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Fleet carbon intensity", unit: "gCO\u2082e/MJ", poiData: poiData, data: (poiData.length
                                    ? [
                                        {
                                            name: "Intensity without transactions",
                                            color: theme_1.theme.colors.grey(2),
                                            data: analysis.intensities.cumulative?.map((d) => ({
                                                date: new Date(d.date),
                                                value: d.intensity.intensity_gCO2e_per_MJ,
                                            })) ?? [],
                                            prediction: forecastsAvailable && forecastDate
                                                ? {
                                                    date: forecastDate,
                                                    value: usageData.fleet.forecast.total
                                                        .intensity_gCO2e_per_MJ,
                                                }
                                                : undefined,
                                        },
                                    ]
                                    : []).concat([
                                    {
                                        name: "Intensity",
                                        color: theme_1.theme.colors.blackText,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.adjusted_intensity_gCO2e_per_MJ,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.fleet.forecast.total
                                                    .adjusted_intensity_gCO2e_per_MJ,
                                            }
                                            : undefined,
                                    },
                                ]), limits: [
                                    {
                                        label: `${carbonLimitYear} limit`,
                                        value: metadata.intensity[carbonLimitYear],
                                        color: theme_1.theme.colors.red,
                                    },
                                ] }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Carbon unit balance", unit: "tCO\u2082e to spare", poiData: poiData, data: (poiData.length
                                    ? [
                                        {
                                            name: "Balance without transactions",
                                            color: theme_1.theme.colors.grey(2),
                                            data: analysis.intensities.cumulative?.map((d) => ({
                                                date: new Date(d.date),
                                                value: d.intensity.emission_balance_ton,
                                            })) ?? [],
                                            prediction: forecastsAvailable && forecastDate
                                                ? {
                                                    date: forecastDate,
                                                    value: usageData.fleet.forecast.total
                                                        .emission_balance_ton,
                                                }
                                                : undefined,
                                        },
                                    ]
                                    : []).concat([
                                    {
                                        name: "Carbon unit balance",
                                        color: theme_1.theme.colors.blackText,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.emission_balance_ton,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.fleet.forecast.total
                                                    .adjusted_emission_balance_ton,
                                            }
                                            : undefined,
                                    },
                                ]) }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Cumulative emissions", unit: "tCO\u2082e", poiData: poiData, data: (poiData.length
                                    ? [
                                        {
                                            name: "Emissions without transactions",
                                            color: theme_1.theme.colors.grey(2),
                                            dashed: false,
                                            data: analysis.intensities.cumulative?.map((d) => ({
                                                date: new Date(d.date),
                                                value: d.intensity.co2_emission_ton,
                                            })) ?? [],
                                            prediction: forecastsAvailable && forecastDate
                                                ? {
                                                    date: forecastDate,
                                                    value: usageData.fleet.forecast.total.co2_emission_ton,
                                                }
                                                : undefined,
                                        },
                                    ]
                                    : []).concat([
                                    {
                                        name: "Emissions",
                                        color: theme_1.theme.colors.blackText,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.co2_emission_ton,
                                        })) ?? [],
                                        dashed: false,
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.fleet.forecast.total
                                                    .adjusted_co2_emission_ton,
                                            }
                                            : undefined,
                                    },
                                    {
                                        name: "Emission limit",
                                        color: theme_1.theme.colors.red,
                                        dashed: true,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.emission_limit_ton,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.fleet.forecast.total.emission_limit_ton,
                                            }
                                            : undefined,
                                    },
                                ]) }) }), analysis.fuel_spent.cumulative_fuel_timeline &&
                            (0, isNonEmptyObject_1.isNonEmptyObject)(analysis.fuel_spent.cumulative_fuel_timeline) && ((0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Cumulative fuel use", unit: "t", data: Object.keys(analysis.fuel_spent.cumulative_fuel_timeline).map((fuelKey, i) => {
                                    const fuelData = analysis.fuel_spent.cumulative_fuel_timeline[fuelKey];
                                    return {
                                        name: metadata.fuels[fuelData.fuel]?.description ??
                                            "Name not found",
                                        color: (0, util_1.getFuelColor)(fuelData.fuel),
                                        data: fuelData.timeline.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.amount,
                                        })),
                                        prediction: undefined,
                                        // forecastFuels && forecastDate
                                        //   ? {
                                        //       date: forecastDate,
                                        //       value: forecastFuels[fuelKey],
                                        //     }
                                        //   : undefined,
                                    };
                                }) }) }))] }), ships.status === apiUtils_1.LoaderStatus.Success ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ShipTable_1.ShipTable, { ships: ships.data, metadata: metadata, year: carbonLimitYear }) }) })) : ((0, jsx_runtime_1.jsx)(common_styled_components_1.P, { children: "Loading\u2026" })), transactionData && transactionData.length > 0 && ((0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Compliance transactions" }), (0, jsx_runtime_1.jsx)(TransactionTable_1.TransactionTable, { transactions: transactionData, complianceYear: carbonLimitYear, poolId: fleetData.id, refresh: refreshTransactions })] }) })), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Voyages" }), voyages.status === apiUtils_1.LoaderStatus.Success ? ((0, jsx_runtime_1.jsx)(VoyageBarChart_1.default, { voyages: voyages.data })) : ((0, jsx_runtime_1.jsx)(common_styled_components_1.P, { children: "Loading\u2026" }))] }) })] }));
    }
    return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Loading fleet\u2026" });
};
